import { useContext, useEffect, useState } from "react";
import { fetchAllDashboards } from "../../../services/b2b-reporting-apiServices";
import { B2BContentContext } from "../../layout/Layout";
import { LoginContext } from "../../../App";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";

const useGettingCustomDashboards = () => {
    const { t } = useB2BTranslation('b2b-reporting');

    const { setNotification } = useContext(B2BContentContext);
    const { loginData } = useContext(LoginContext);

    const [ customDashboards, setCustomDashboards ] = useState(null);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ refresh, setRefresh ] = useState(false);
    
    const getAllDashboards = async () => {
        setIsLoading(true);
        try {
            const dashboards = await fetchAllDashboards(loginData.accessToken, loginData.loggedOrganizationUuid);
            setCustomDashboards(dashboards);
        } catch (error) {
            console.error('Error fetching dashboards:', error);
            showNotification(setNotification, `${t('Error fetching dashboards: ') + error.message}`, 'error', 5000);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllDashboards();
    }, []);

    useEffect(() => {
        if (refresh) {
            getAllDashboards();
            setRefresh(false);
        }
    }, [refresh]);

    const refreshDashboards = () => {
        setRefresh(true);
    }

    return { customDashboards, isLoading, refreshDashboards };
}

export default useGettingCustomDashboards;